import fetch from '@/utils/fetch'

// 签约状态
export const apiSignStatus = () => fetch('/a/selector/signStatus')

// 地区
export const apiRegion = () => fetch('/a/selector/region')

// 认证审核状态
export const apiCheckStatus = () => fetch('/a/selector/certificationStatus')

// 用户实名认证情况
export const apiRealNameStatus = () => fetch('/a/selector/userCertificationStatus')

// 行业
export const apiIndustries = () => fetch('/a/selector/industries')

// 性别
export const apiGender = () => fetch('/a/selector/gender')

// 学历
export const apiEducation = () => fetch('/a/selector/educationLevel')

// 购车情况
export const apiHasCar = () => fetch('/a/selector/hasCar')

// 婚姻状况
export const apiMarriage = () => fetch('/a/selector/marriageHistory')

// 支付方式
export const apiPayments = () => fetch('/a/selector/payments')

// 嘉宾类型
export const apiUserTypes = () => fetch('/a/selector/userTypes')

// 上架状态
export const apiShowStatus = () => fetch('/a/selector/showStatus')

// 红娘列表
export const apiMatchmakers = () => fetch('/a/selector/matchMakers')

// 是否到店
export const apiArriveStatus = () => fetch('/a/selector/arriveStatus')

// 购房情况
export const apiHasHouse = () => fetch('/a/selector/hasHouse')

// 兴趣爱好
export const apiHobbies = () => fetch('/a/selector/hobbies')

// 恋爱史
export const apiLoveHistory = () => fetch('/a/selector/loveHistory')

// 是否脱单
export const apiSingleStatus = () => fetch('/a/selector/singleStatus')

// 购车需求
export const apiCarRequirement = () => fetch('/a/selector/carRequirement')

// 购房需求
export const apiHouseRequirement = () => fetch('/a/selector/houseRequirement')

// 学历要求
export const apiEducationalRequirement = () => fetch('/a/selector/educationalRequirements')
